module.exports = __webpack_public_path__ + "img/avatar-pressure-high.cee865b6.png";